export default {
  'TopicsDonutChart.title': 'Popular topics',
}
